var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-group-item"},[_c('div',{staticClass:"avatar"},[_c('head-image',{attrs:{"url":_vm.templateGroup.avatar,"name":_vm.templateGroup.groupName}})],1),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(_vm.templateGroup.groupName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }